<div class="flex flex-col portrait:min-h-screen">
  <pax-header
    [acceptedLanguages]="acceptedLanguages"
    [initialLanguage]="initialLanguage"
    (changedLanguage)="setLanguage($event)"
  />
  <ng-content></ng-content>
  @if (!minimal) {
  <pax-footer />
  }
</div>
